import { required } from 'vuelidate/lib/validators';
import { FormElement } from '@/types/forms/formElement';
import { FormOption } from '@/types/forms/formOption';
import { DateField } from '@/types/forms/fields/dateField';
import { TextField } from '@/types/forms/fields/textField';
import { RadioButtonsField } from '@/types/forms/fields/radioButtonsField';
import { iban } from '@/validators/iban';
import { BillingFormStep } from '@/types/forms/formSteps/billingFormStep';
import { CheckboxField } from '@/types/forms/fields/checkboxField';
import { requiredDate } from '@/validators/requiredDate';
import { minDateNow } from '@/validators/minDateNow';
import { maxDate3Months } from '@/validators/maxDate3Months';
import { checked } from '@/validators/checked';
import { isTaxNumber } from '@/validators/isTaxNumber';

export const billingFormStep = new BillingFormStep({
    paymentRequirements: new FormElement(),
    plantSalesMethodAssignment: new RadioButtonsField({
        value: 'statutoryCompensation',
        options: [
            new FormOption({ key: 'statutoryCompensation' }),
            new FormOption({ key: 'directMarketingMarketPremium' }),
            new FormOption({ key: 'otherDirectMarketing' }),
            new FormOption({ key: 'freeAcceptance' }),
        ],
        validators: {
            required,
        },
    }),
    noEegRemuneration: new CheckboxField(),
    reasonNoEegRemuneration: new RadioButtonsField({
        value: 'economicDisadvantages',
        options: [
            new FormOption({ key: 'economicDisadvantages' }),
            new FormOption({ key: 'other' }),
        ],
        validators: {
            required,
        },
    }),
    explanationNoEegRemuneration: new TextField({
        validators: {
            required,
        },
    }),
    noEegRemunerationHint: new FormElement(),
    taxNumberWillFollow: new CheckboxField(),
    taxNumber: new TextField({
        validators: {
            required,
            isTaxNumber,
        },
    }),
    smallPVTaxAdvisorHint: new FormElement(),
    matchingTaxIDHint: new FormElement(),
    tax: new RadioButtonsField({
        value: 'noSalesTax',
        options: [
            new FormOption({ key: 'noSalesTax' }),
            new FormOption({ key: 'salesTax' }),
        ],
        validators: {
            required,
        },
    }),
    noFinancialDistress: new CheckboxField({
        validators: {
            checked,
        },
    }),
    noPendingEURecoveryClaims: new CheckboxField({
        validators: {
            checked,
        },
    }),
    directDebitMandate: new FormElement(),
    iban: new TextField({
        validators: {
            required,
            iban,
        },
    }),
    nameAndDomicileCreditInstitution: new TextField(),
    date: new DateField({
        validators: {
            requiredDate,
            minDateNow,
            maxDate3Months,
        },
    }),
    accountOwnerName: new TextField({
        validators: {
            required,
        },
    }),
});
